import * as _ from 'lodash';

import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { AccountService } from 'app/main/pages/authentication/login/account.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ProfileService } from 'app/main/tradesperson/profile/profile.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

// import { navigation } from 'app/navigation/navigation';


@Component({
    selector     : 'toolbar',
    templateUrl  : './toolbar.component.html',
    styleUrls    : ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    userId
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    // navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    usarName: string;
    profilePicture
    
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private profileService: ProfileService,
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        public accountService: AccountService
    )
    {
        //this.profilePicture = 'assets/images/avatars/default-user.jpg';
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon : 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon : 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon : 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'tr',
                title: 'Turkish',
                flag : 'tr'
            }
        ];

        // this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
      //  this.usarName = this.accountService.userAccount.userName;
      if(localStorage.getItem('user') != null){
        this.usarName = JSON.parse(localStorage.getItem('user')).userName;
        // this.userId = JSON.parse(localStorage.getItem('user')).userId;
        this.userId = JSON.parse(localStorage.getItem('user')).id;
      }
      this.loadProfile();
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
               this.horizontalNavbar = settings.layout.navbar.position === 'top';
                // this.horizontalNavbar = true;
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});
    }

    
    loadProfile(): void{
        if(JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).picture === ""){
            this.profilePicture = 'assets/images/avatars/default-user.jpg';
        }
        else if(JSON.parse(localStorage.getItem("user"))){
            this.profilePicture = JSON.parse(localStorage.getItem("user")).picture;
        }
        
        // this.profileService.getMyProfileById(this.userId)
        //   .subscribe(data => {
        //       if(data !== null){
        //         if(data.profilePicture === null){
        //             this.profilePicture = 'assets/images/avatars/default-user.jpg';
        //           }
        //           else{
        //             this.profilePicture = data.profilePicture;
        //           }
        //       }else{
        //         this.profilePicture = 'assets/images/avatars/default-user.jpg';
        //       }
        //   }, error => console.log(error));
      }


    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    logOut(){
        this.accountService.logout();
        // const values = localStorage.getItem('dataSource');
        localStorage.clear();
    }
}
